import React, { useEffect } from "react";
import { connect, useSelector } from "react-redux";
import { getDailyPnl } from "../../actions/dashboard-action";
import { currencyFormat,getCurrencySymbol } from "../../utils/Utils";

const BalanceInfo = (props)=>{
    const {t,selectedExchangeId,getDailyPnl} = props
    const currency = useSelector((state) => state.settings.currency) || "USD";
    const dailyPnl = useSelector((state) => state.dashboard.dailyPnl) || {};
    const allPnL = (dailyPnl.pnl && dailyPnl.pnl.fiat) || "0";
    const assets = useSelector((state) => state.dashboard.assets) || {};
    const cashBalance = assets && assets.cash || "0";
    const fiatBalance = assets && assets.balance_fiat || "0";

    useEffect(() => {
      const refreshDailyPnl = () => {
        getDailyPnl(selectedExchangeId);
      };

      const handleVisibilityChange = () => {
        if (!document.hidden) {
          refreshDailyPnl();
        }
      };

      refreshDailyPnl();
      window.addEventListener("focus", refreshDailyPnl);
      document.addEventListener("visibilitychange", handleVisibilityChange);
      const intervalId = window.setInterval(refreshDailyPnl, 15 * 60 * 1000);

      return () => {
        window.removeEventListener("focus", refreshDailyPnl);
        document.removeEventListener("visibilitychange", handleVisibilityChange);
        window.clearInterval(intervalId);
      };
    }, [selectedExchangeId, getDailyPnl]);

    return (
      <div className="newuser-earning-area">
      <div className="newuser-cash-content">
        <button><img src="images/icon-cash.svg" alt="cash"/></button>
        <div>
          <span>Cash</span>
          <h5>{getCurrencySymbol(selectedExchangeId,currency)} {currencyFormat(cashBalance)}</h5>
        </div>
      </div>
      <div className="newuser-cash-content">
        <button><img src="images/icon-trade.svg" alt="cash"/></button>
        <div>
          <span>Portfolio</span>
          <h5>{getCurrencySymbol(selectedExchangeId,currency)} {currencyFormat(fiatBalance)}</h5>
        </div>
      </div>
      <div className="newuser-cash-content">
        <button><img src="images/icon-quity.svg" alt="cash"/></button>
        <div>
          <span>Total Returns</span>
          <h5>{getCurrencySymbol(selectedExchangeId,currency)} {allPnL}</h5>
        </div>
      </div>
    </div>
    )
}

export default connect(null,{getDailyPnl}) (BalanceInfo);
